import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import { useState } from 'react'
import { nextPage } from 'components/RCPro/helpers/nav'
import Calendar from 'react-calendar'
import Arrow from 'components/assets/icons/Arrow'
import Radio from 'components/common/Radio/Radio'
import InputError from 'components/common/InputError/InputError'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Activation.module.scss'
import 'react-calendar/dist/Calendar.css';
import './Calendar.scss'

const RCProActivation = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const [ selectedDate, setSelectedDate ] = useState(state.activation || new Date())
  const { activation, layout: { next } } = state.texts
  const maxDate = new Date()
  maxDate.setMonth( maxDate.getMonth() + 6 )
  const options = [
    t('mainReporting:form.activation.today'),
    t('mainReporting:form.activation.later')
  ]

  // Initialize form
  const required = t('mainReporting:form.mandatory')
  const {
    register,
    formState: { errors, isValid },
    handleSubmit,
    watch
  } = useForm({
    ...formParams,
    values: {
      activation: state.activation || ''
    },
  })

  const onSubmit = handleSubmit(async data => {
    const activation = data.activation === options[0]
      ? new Date()
      : selectedDate
    nextPage({ pathname, state, navigate, data: { activation } })
    nextPageTransition()
  })

  return (
    <>
      <h1>{activation.title}</h1>
      <p>{activation.legend}</p>

      <form onSubmit={onSubmit}>
        <Radio
          register={register('activation', { required })}
          className={style.radio}
          values={options}
        />
        <InputError error={errors.activation} />

        {watch("activation") === options[1] &&
          <Calendar
            onChange={setSelectedDate}
            value={selectedDate}
            minDate={new Date()}
            maxDate={maxDate}
          />
        }

        <Button
          label={<>{next} <Arrow /></>}
          onClick={handleSubmit}
          disabled={!isValid}
          type="primary"
        />
      </form>
    </>
  )
}

export default RCProActivation